import { MouseEvent, useState } from 'react';
import { MoreActionsItem } from '../moreActionsButton.types';

export function useMoreActionsButton() {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const isOpen = Boolean(anchorEl);

  const open = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const close = () => {
    setAnchorEl(null);
  };

  const handleItemClick = (action: MoreActionsItem) => {
    action.onClick();
    close();
  };

  return { anchorEl, isOpen, open, close, handleItemClick };
}
